<template>
    <div class="home-bg">
        <header-div />
        <loading-screen v-if="loadingScreen" />
        <section class="home-container">
            <div class="form-container" v-if="loadingScreen">
                <div class="form-box">
                    <div>

                    </div>
                </div>
            </div>
            <div class="form-container" v-if="!notFound && !loadingScreen">
                <div class="form-box">
                    <div>
                        <h1>
                            Insira sua nova senha para acessar o Health ID Lab
                        </h1>
                        <p>
                        
                        </p>
                    </div>
                    <form @submit="handleSubmit">
                        <div class="input-box">
                            <label for="password">Nova senha *</label>
                            <span class="password-icon">
                                <font-awesome-icon :icon="['fa', 'eye-slash']" @click="handleShowPassword(0)"
                                                    v-if="!showPassword"/>
                                <font-awesome-icon :icon="['fa', 'eye']" @click="handleShowPassword(0)" v-if="showPassword"/>
                            </span>
                            <input
                                id="password"
                                name="password"
                                type="password"
                                v-model="form.password"/>
                            <small class="error" v-if="errors && errors.password">{{errors.password.join()}}</small>
                        </div>
                        <div class="input-box">
                            <label for="confirm_password">Confirmar nova senha *</label>
                            <span class="password-icon">
                                <font-awesome-icon :icon="['fa', 'eye-slash']" @click="handleShowPassword(1)"
                                                    v-if="!showConfirmPassword"/>
                                <font-awesome-icon :icon="['fa', 'eye']" @click="handleShowPassword(1)"
                                                    v-if="showConfirmPassword"/>
                            </span>
                            <input
                                id="confirm_password"
                                name="confirm_password"
                                type="password"
                                v-model="form.password_confirmation"/>
                        </div>
                        <div class="form-actions" v-if="!confirmed">
                            <button v-if="!loading" class="button btn-orange">
                                RECUPERAR
                            </button>
                            <button v-if="loading" class="button btn-orange" disabled>
                                <loading />
                            </button>
                        </div>
                        <div class="form-actions" v-if="confirmed">
                            <p>Sua senha foi alterada com sucesso! Clique <a href="../">aqui</a> para fazer o seu login.</p>
                        </div>
                    </form>
                </div>
            </div>
            <div class="form-container" v-if="notFound && !loadingScreen">
                <div class="form-box">
                    <div>
                        <h1>
                            Não foi possível solicitar uma nova senha
                        </h1>
                        <p>
                            O link que você acessou pode ser inválido ou já tenha sido expirado. Clique aqui para solicitar uma nova senha.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import { VERIFY_FORGOT_PASSWORD, RECOVER_PASSWORD } from '../../services/user'
    import { User } from '../../models/User'

    export default {
        components: {  },
        data() {
            return {
                loading: false,
                loadingScreen: false,
                showPassword: false,
                showConfirmPassword: false,
                form: {
                    email: null,
                    token: null,
                    password: null,
                    password_confirmation: null
                },
                notFound: false,
                confirmed: false,
            }
        },
        methods: {
            handleVerify(form) {
                this.loadingScreen = true;
                VERIFY_FORGOT_PASSWORD(form).then(
                    resp => {
                        
                    },
                    error => this.notFound = true,
                    ).then(
                    resp => {
                        this.loadingScreen = false;
                    }
                );
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.loading = true;
                RECOVER_PASSWORD(this.form).then(
                    resp => {
                        this.confirmed = true;
                    },
                    error => this.errors = error.response.data.errors,
                    ).then(
                    resp => {
                        this.loading = false;
                    }
                );
            },
            validate(form) {
                let valid = true;
                for (const i in form.$children) {
                    let item = form.$children;
                    if(item[i].$options._componentTag == "header-div")
                        continue;
                    item[i].validate();
                    if(item[i].type == 'password_confirm' && (this.form.password != this.form.password_confirmation)){
                        item[i].errorMessage = 'As senhas digitadas não são iguais.'
                    }
                    if(item[i].errorMessage !== null)
                        valid = false;
                }
                return valid;
            },
        },
        mounted() {
            let url_string = window.location.href;
            let url = new URL(url_string);
            this.form.email = url.searchParams.get("email");
            this.form.token = url.searchParams.get("token");

            const form = {
                email: this.form.email,
                token: this.form.token
            }

            this.handleVerify(form);
        }
    }
</script>

<style scoped>
    @import "../Home/home.scss";
    @import "../Home/responsive.css";
</style>


// WEBPACK FOOTER //
// src/views/RecoverPassword/RecoverPassword.vue